<template>
	<form action="#" method="post" @submit.prevent="submit">
		<!-- Form Fields -->
		<h2>Contact Information</h2>
		<p class="mb-md-5 pb-4"><strong>Thanks, <span>{{ name }}</span>!</strong> We need a few more details:</p>
		<div class="form-field">
			<label for="address1" class="form-label">Address Line 1</label>
			<input type="text" class="form-control" name="address1" id="address1" placeholder="This should be the address for the text purpose" required v-model="address1">
		</div>
		<div class="form-field mt-3 pt-3">
			<label for="address2" class="form-label">Address Line 2</label>
			<input type="text" class="form-control" name="address2" id="address2" placeholder="Enter if applicable" v-model="address2">
		</div>
		<div class="row">
			<div class="col-md-6 mt-3 pt-3">
				<div class="form-field">
					<label for="city" class="form-label">City</label>
					<input type="text" class="form-control" name="city" id="city" placeholder="Enter city name" required v-model="city">
				</div>
			</div>
			<div class="col-md-6 mt-3 pt-3">
				<div class="form-field">
					<label for="state" class="form-label">State</label>
					<select class="form-control" name="state" id="state" required v-model="state">
						<option disabled selected value="">Select state</option>
						<option value="AL">Alabama</option>
						<option value="AK">Alaska</option>
						<option value="AZ">Arizona</option>
						<option value="AR">Arkansas</option>
						<option value="CA">California</option>
						<option value="CO">Colorado</option>
						<option value="CT">Connecticut</option>
						<option value="DE">Delaware</option>
						<option value="DC">District Of Columbia</option>
						<option value="FL" disabled>Florida</option>
						<option value="GA">Georgia</option>
						<option value="HI">Hawaii</option>
						<option value="ID">Idaho</option>
						<option value="IL">Illinois</option>
						<option value="IN">Indiana</option>
						<option value="IA">Iowa</option>
						<option value="KS">Kansas</option>
						<option value="KY">Kentucky</option>
						<option value="LA">Louisiana</option>
						<option value="ME">Maine</option>
						<option value="MD">Maryland</option>
						<option value="MA">Massachusetts</option>
						<option value="MI">Michigan</option>
						<option value="MN">Minnesota</option>
						<option value="MS">Mississippi</option>
						<option value="MO">Missouri</option>
						<option value="MT">Montana</option>
						<option value="NE">Nebraska</option>
						<option value="NV">Nevada</option>
						<option value="NH">New Hampshire</option>
						<option value="NJ" disabled>New Jersey</option>
						<option value="NM">New Mexico</option>
						<option value="NY">New York</option>
						<option value="NC">North Carolina</option>
						<option value="ND">North Dakota</option>
						<option value="OH">Ohio</option>
						<option value="OK">Oklahoma</option>
						<option value="OR">Oregon</option>
						<option value="PA">Pennsylvania</option>
						<option value="RI">Rhode Island</option>
						<option value="SC">South Carolina</option>
						<option value="SD">South Dakota</option>
						<option value="TN">Tennessee</option>
						<option value="TX" disabled>Texas</option>
						<option value="UT">Utah</option>
						<option value="VT">Vermont</option>
						<option value="VA">Virginia</option>
						<option value="WA" disabled>Washington</option>
						<option value="WV">West Virginia</option>
						<option value="WI">Wisconsin</option>
						<option value="WY">Wyoming</option>
					</select>
				</div>
			</div>
			<div class="col-md-4 mt-3 pt-3">
				<div class="form-field">
					<label for="zip" class="form-label">ZIP Code</label>
					<input type="text" class="form-control" name="zip" id="zip" placeholder="Enter zip code" required v-model="zip">
				</div>
			</div>
		</div>
		<p class="mt-3">By continuing, you certify that you are a U.S. citizen.</p>

		<h4 class="mt-md-4 pt-5">Tax Reporting Details</h4>
		<div class="form-field mt-3 pt-3">
			<label for="ssn" class="form-label">Social Security Number</label>
			<input type="text" class="form-control" name="ssn" id="ssn" placeholder="Enter 9 digit SSN" v-model="ssn" required>
			<p class="text-danger fw-bolder mt-2 small" v-if="showErrors && showErrors === 'invalid_ssn'">Please enter valid Social Security Number.</p>
		</div>
		<div class="form-field mt-3 pt-3">
			<label for="birthday" class="form-label">Date of Birth</label>
			<input type="date" class="form-control" name="birthday" id="birthday" v-model="birthday" required>
		</div>
		<p class="text-danger fw-bolder mt-2 small" v-if="showErrors && showErrors === 'too_young'">You must be older than 18 years to proceed forward.</p>

		<!-- Form Navigation -->
		<div class="d-flex flex-column-reverse flex-md-row justify-content-md-end pt-5">
			<button class="btn btn-outline-dark me-md-2 mt-2 mt-md-0" type="button" @click.prevent="back" :disabled="loading">Back</button>
			<button class="btn btn-primary btn-wide" type="submit" :disabled="loading">
				<span class="spinner-border" v-if="loading"></span>
				<span v-if="!loading">Confirm &amp; Save</span>
			</button>
		</div>
	</form>
</template>

<script>
import repository from "@/repository/repository";
import Logs from "@/repository/logs";

export default {
    name: "ContactTaxForm",
    beforeMount() {
        // Verify the previous step is completed
        if(!this.$store.getters.basic.completed) {
            this.$router.replace("/details");
        }

        // Verify if the current step is finished
		if(this.$store.getters.contact.finished) {
            if(this.$store.getters.kyc.required && !this.$store.getters.kyc.finished) {
                this.$router.replace("/details/kyc");
			} else {
                this.$router.replace("/details/investment-plan");
			}
		}
    },
    data() {
        return {
            name: this.$store.getters.personal.firstName,
            address1: this.$store.getters.contact.address1,
            address2: this.$store.getters.contact.address2,
            city: this.$store.getters.contact.city,
            state: this.$store.getters.contact.state,
            zip: this.$store.getters.contact.zip,
            ssn: this.$store.getters.contact.ssn,
            birthday: this.$store.getters.contact.birthday,
            showErrors: false,
			loading: false,
        }
    },
    methods: {
        back() {
            this.$store.commit("updateContact", {
                address1: this.address1,
                address2: this.address2,
                city: this.city,
                state: this.state,
                zip: this.zip,
                ssn: this.ssn,
                birthday: this.birthday,
            });
            this.$router.back();
        },
        submit() {
            if(!this.checkSSN()) {
                this.showErrors = 'invalid_ssn';
                return false;
            }
            if(!this.checkBirthday()) {
                this.showErrors = 'too_young';
                return false;
            }

            // Start loading effect
            this.loading = true;

            // Save updates in store
            this.$store.commit("updateContact", {
                address1: this.address1,
                address2: this.address2,
                city: this.city,
                state: this.state,
                zip: this.zip,
                ssn: this.ssn,
                birthday: this.birthday,
            });

            // Send request to save the current data
			let payload = {
                firstName: this.$store.getters.personal.firstName,
                lastName: this.$store.getters.personal.lastName,
                socialSecurityNumber: this.$store.getters.contact.ssn,
                birthday: this.$store.getters.contact.birthday,
                country: 'USA',
                address1: this.$store.getters.contact.address1,
                address2: this.$store.getters.contact.address2,
                city: this.$store.getters.contact.city,
                state: this.$store.getters.contact.state,
                zip: this.$store.getters.contact.zip,
                emailAddress: this.$store.getters.auth.email,
                phone: this.$store.getters.personal.phone,
                accountType: (this.$store.getters.basic.accountType === 'Individual' ? 'Individual' : this.$store.getters.basic.otherAccountType),
                entityType: this.$store.getters.basic.entity.type,
                linkType: this.$store.getters.basic.otherAccountRelation,
                accreditedStatus: this.$store.getters.basic.accreditedInvestor,
                yearlyInvestment: this.$store.getters.basic.yearlyInvestment,
                entityName: this.$store.getters.basic.entity.name,
                ein: this.$store.getters.basic.entity.ein,
                entityAddress1: this.$store.getters.basic.entity.address1,
                entityAddress2: this.$store.getters.basic.entity.address2,
                entityCity: this.$store.getters.basic.entity.city,
                entityState: this.$store.getters.basic.entity.state,
                entityZip: this.$store.getters.basic.entity.zip,
                entityEmailAddress: this.$store.getters.basic.entity.email,
                entityPhone: this.$store.getters.basic.entity.phone,
                secondPartyFirstName: this.$store.getters.basic.secondary.firstName,
                secondPartyLastName: this.$store.getters.basic.secondary.lastName,
                secondPartySocialSecurityNumber: this.$store.getters.basic.secondary.ssn,
                secondPartyBirthday: this.$store.getters.basic.secondary.birthday,
                secondPartyCountry: 'USA',
                secondPartyAddress1: this.$store.getters.basic.secondary.address1,
                secondPartyAddress2: this.$store.getters.basic.secondary.address2,
                secondPartyCity: this.$store.getters.basic.secondary.city,
                secondPartyState: this.$store.getters.basic.secondary.state,
                secondPartyZip: this.$store.getters.basic.secondary.zip,
                secondPartyLinkType: this.$store.getters.basic.secondary.relation,
            };
			repository.post("/process", payload)
				.then(response => {
                    console.log(response);
                    this.loading = false;
                    this.$store.commit("finishPersonal");
                    this.$store.commit("finishBasic");
                    this.$store.commit("finishContact");
                    this.$store.commit("updateNorthCapital", response.data);

                    // If KYC or AML failed, redirect to KYC screen
                    if(response.data.kyc === false || response.data.aml === false) {
                        this.$store.commit("requireKYC");
                        this.$router.push("/details/kyc");
					} else {
                        this.$router.push("/details/investment-plan");
					}
				})
				.catch(error => {
                    console.log(error);
                    Logs.save('onboarding.contactTaxForm', error.response, payload);
				})

        },
        checkSSN() {
            if(!this.ssn) return false;
            if(/^[0-9]{9}$/.test(this.ssn)) return true;
            if(/^[0-9]{3}-[0-9]{2}-[0-9]{4}$/.test(this.ssn)) return true;
            return false;
		},
        checkBirthday() {
            return this._calculateAge(new Date(this.birthday)) >= 18;
		},
        _calculateAge(birthday) {
            let ageDifMs = Date.now() - birthday.getTime();
            let ageDate = new Date(ageDifMs);
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        },
    },
}
</script>